import React, { useState } from 'react'
import PropTypes from 'prop-types'
import { DialogTitle, DialogContent, Button, Dialog } from '@material-ui/core'
import { toNameCase } from '../../../utils'
import NewItemDialogButton from './NewItemDialogButton'

function NewItemDialog({ dialog, setDialog, createItem }) {
    const [type, setType] = useState(null)

    const complexities = ['low', 'standard', 'high', 'custom']

    return (
        <Dialog
            open={dialog}
            onExited={() => setType(null)}
            onClose={() => setDialog(false)}
            aria-labelledby="new-item-dialog-title"
            maxWidth="xs"
            fullWidth
        >
            <DialogTitle id="new-item-dialog-title">
                {!type ? 'Item type' : 'Complexity'}
            </DialogTitle>
            <DialogContent>
                <div style={{ display: 'flex', flexDirection: 'column' }}>
                    {!type ? (
                        <>
                            <NewItemDialogButton
                                onClick={() => setType('mbox')}
                            >
                                M-Box
                            </NewItemDialogButton>

                            <NewItemDialogButton
                                onClick={() => {
                                    createItem('quicklink')
                                    setDialog(false)
                                }}
                            >
                                Quicklink
                            </NewItemDialogButton>

                            <NewItemDialogButton
                                onClick={() => {
                                    createItem('mobileUpload')
                                    setDialog(false)
                                }}
                            >
                                Mobile upload
                            </NewItemDialogButton>
                        </>
                    ) : (
                        <>
                            {complexities.map((comp) => (
                                <Button
                                    key={comp}
                                    style={{ marginBottom: 12 }}
                                    variant="contained"
                                    color="primary"
                                    onClick={() => {
                                        createItem(type, comp)
                                        setDialog(false)
                                    }}
                                >
                                    {toNameCase(comp)}
                                </Button>
                            ))}
                        </>
                    )}
                </div>
            </DialogContent>
        </Dialog>
    )
}

NewItemDialog.propTypes = {
    dialog: PropTypes.bool,
    setDialog: PropTypes.func,
    createItem: PropTypes.func
}

export default NewItemDialog
